"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageContainer = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _useAppLayout2 = require("../layout/app-layout/useAppLayout");
var _context = require("../context");
var _layout = require("../layout");
var _utils = require("../utils");
var _core = require("@emotion/core");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var PageContainerBase = function PageContainerBase(containerProps) {
  var _useAppLayout = (0, _useAppLayout2.useAppLayout)(),
    isInAppLayout = _useAppLayout.isInAppLayout;
  return (0, _core.jsx)(_context.StencilConsumer, null, function (_ref) {
    var selectors = _ref.selectors;
    return (0, _core.jsx)(_layout.Container, (0, _extends2.default)({
      isInAppLayout: isInAppLayout,
      paddingHorizontal: selectors.constant('pageHorizontalPadding')
    }, containerProps));
  });
};
PageContainerBase.defaultProps = _objectSpread(_objectSpread({}, (0, _utils.omit)(_layout.Container.defaultProps, ['paddingHorizontal'])), {}, {
  paddingTop: 'S600',
  paddingBottom: 'S700'
});
var PageContainerWithDocs = (0, _stencilReactDesc.describe)(PageContainerBase).description('Page container with consistent padding and maximum width.');
PageContainerWithDocs.propTypes = _objectSpread({}, _layout.Container.describedPropTypes);
var PageContainer = (0, _utils.withTestAttributes)({
  id: 'StencilReactPageContainer'
})(PageContainerWithDocs);
exports.PageContainer = PageContainer;
PageContainer.displayName = 'PageContainer';